'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'

export const FormPanel = ({ children }) => {
  return (
    <MUIStack
      gap={5}
      data-testid="FormPanel"
      sx={{
        backgroundColor: 'white'
      }}
    >
      {children}
    </MUIStack>
  )
}

FormPanel.propTypes = {
  children: PropTypes.node
}
